import { useRef, useEffect, useState, useCallback} from 'react'
import Collapse from '#Components/Collapse'
import { Button } from 'react-bootstrap';

const {REACT_APP_TESSERACT_TARGET} = process.env

function Demo_Capstone({ setModalProps, setDismiss }) {
    const window1 = useRef(null);
    const [collapsed, setCollapsed] = useState(true);

    return (
        <>
            <iframe ref={window1} src={`${REACT_APP_TESSERACT_TARGET}v1/`} name='_DEMO playerOneWindow' title='playerOneWindow' ></iframe>
            <div className="position-absolute bottom-0 d-flex flex-column justify-content-center modalClosureCollapse rocky">
                <Button className='d-flex' onClick={() => setCollapsed(!collapsed)}
                    style={{
                        width: 'min-content', alignSelf: 'center',
                        borderTopLeftRadius: '50% 50%', 
                        borderTopRightRadius: '50% 50%', 
                    }}>
                    <i className={`fa fa-angle-double-up px-3`} style={{transform: collapsed ? '' : 'rotate(180deg)', transition: 'transform 500ms'}}></i>
                </Button>
                <Collapse {...{ collapsed, setCollapsed, duration: 500 }}>
                    <Button onClick={()=>setModalProps({showing: false})}>
                        <p className='m-0 pt-1'>Exit Demonstration</p>
                    </Button>
                </Collapse>
            </div>
        </>
    )
}
function Demo_1Player({ setModalProps, setDismiss }) {
    const window1 = useRef(null);
    const [collapsed, setCollapsed] = useState(true);

    useEffect(() => {
        setDismiss(() => () => {
            window1.current.contentWindow.postMessage('_LOGOUT', '*');
        })
    }, [])

    return (
        <>
            <iframe ref={window1} src={REACT_APP_TESSERACT_TARGET} name='_DEMO playerOneWindow' title='playerOneWindow' ></iframe>
            <div className="position-absolute bottom-0 d-flex flex-column justify-content-center modalClosureCollapse rocky">
                <Button className='d-flex' onClick={() => setCollapsed(!collapsed)}
                    style={{
                        width: 'min-content', alignSelf: 'center',
                        borderTopLeftRadius: '50% 50%', 
                        borderTopRightRadius: '50% 50%', 
                    }}>
                    <i className={`fa fa-angle-double-up px-3`} style={{transform: collapsed ? '' : 'rotate(180deg)', transition: 'transform 500ms'}}></i>
                </Button>
                <Collapse {...{ collapsed, setCollapsed, duration: 500 }}>
                    <Button onClick={()=>setModalProps({showing: false})}>
                        <p className='m-0 pt-1'>Exit Demonstration</p>
                    </Button>
                </Collapse>
            </div>
        </>
    )
}

function Demo_2Player({ setDismiss, setModalProps}) {
    //original plan to limit parent cookie access from within iframes was unsuccessful, used different approach to manually handle cookie values in demo mode
    //idea was that by sandboxing w/o allow-same-origin, iframe isn't allowed access to parent document cookies.
    // sandbox="allow-scripts"
    //however, was throwing error for invalid Host/Origin headers in webpack dev server. 

    const window1 = useRef(null);
    const window2 = useRef(null);
    const [focused, setFocused] = useState(1); 
    const messageHandler = useCallback((e) => {
        // for switching focus between game windows
        if (e.data === 'toggleFocus') {
            focused === 1 ? setFocused(2) : setFocused(1); 
        }
    }, [focused])

    useEffect(() => {
        //actually trigger focus events on windows
        if (focused === 1 && window1.current) window1.current.focus(); 
        if (focused === 2 && window2.current) window2.current.focus(); 
    }, [focused, window1, window2])

    useEffect(() => {
        window.addEventListener('message', messageHandler); 
        return () => window.removeEventListener('message', messageHandler); 
    }, [messageHandler])

    useEffect(() => {
        setDismiss(() => () => {
            window1.current.contentWindow.postMessage('_LOGOUT', '*');
            window2.current.contentWindow.postMessage('_LOGOUT', '*');
        })
    }, [])

    return (
        <>
            <iframe ref={window1} src={REACT_APP_TESSERACT_TARGET} name='_DEMO playerOneWindow' title='playerOneWindow'
                className={`${focused !== 1 ? 'blurry' : ''}`}
                onFocus={() => setFocused(1)}
                onMouseEnter={() => setFocused(1)}
                // onMouseLeave={() => setFocused(0)}
            ></iframe>
            <div className="align-self-center light d-flex flex-column fs-1 rocky mx-4">
                <div style={{ background: 'var(--dark)' }}>
                    <Button className={`text-center fs-2 pt-3 w-100`} variant="outline-light" onClick={() => setFocused(focused === 1 ? 2 : 1)}>
                        <i className={`fa fa-random spark`} style={{ transform: (focused === 1 ? '': 'rotate(-180deg)'), transition: 'transform 500ms' }}></i>
                        <br />
                        Focus
                    </Button>
                </div>
                <div style={{ height: '100px' }}></div>
                <div style={{ background: 'var(--dark)' }}>
                    <Button className={`text-center fs-2 pt-3 w-100`} variant="outline-light" onClick={() => setModalProps({ showing: false })}>
                        <i className={`fa fa-undo spark`} ></i>
                        <br />
                        Exit
                    </Button>
                </div>
            </div>
            <iframe ref={window2} src={REACT_APP_TESSERACT_TARGET} name='_DEMO playerTwoWindow' title='playerTwoWindow'
                className={`${focused !== 2 ? 'blurry' : ''}`}
                onFocus={() => setFocused(2)}
                onMouseEnter={() => setFocused(2)}
                // onMouseLeave={() => setFocused(0)}
            ></iframe>
        </>
    )
}

export default {
    Demo_2Player, Demo_1Player, Demo_Capstone
}
